import { gql } from "apollo-boost"

export const getObjectives = gql`
  query SubmissionObjectives($id: ID!) {
    SubmissionObjectives(id: $id) {
      id
      allies
      alliedOne
      alliedTwo
      endDate
      startDate
      generalObjective
      developmentObjective
      reports {
        period
      }
      specificObjectives {
        id
        description
        orderIndex
        indicators {
          id
          isBlocking
          goal
          title
          formula
          baseline
          products
          orderIndex
          methodology
          description
          meansOfVerification
          meansOfVerificationPerMonth {
            id
            month
            year
            monthProgress
            excessProgress
          }
        }
        activities {
          id
          isBlocking
          goal
          title
          place
          inputs
          months
          formula
          baseline
          products
          orderIndex
          methodology
          description
          responsible
          meansOfVerification
          estimatedParticipants
          meansOfVerificationPerMonth {
            id
            month
            year
            monthProgress
            excessProgress
          }
        }
      }
      generalObjectiveIndicators {
        id
        goal
        title
        formula
        baseline
        products
        description
        orderIndex
        methodology
        meansOfVerification
        meansOfVerificationPerMonth {
          id
          month
          year
          monthProgress
          excessProgress
        }
      }
      developmentObjectiveIndicators {
        id
        goal
        title
        formula
        orderIndex
        baseline
        products
        methodology
        description
        meansOfVerification
        meansOfVerificationPerMonth {
          id
          month
          year
          monthProgress
          excessProgress
        }
      }
    }
  }
`
